// nav label
document.addEventListener("DOMContentLoaded", () => {
  const $nav = Array.prototype.slice.call(document.querySelectorAll('.header-nav'), 0);
  if ($nav.length > 0) {
    document.querySelectorAll('.header-nav li a').forEach((element) => {
      element.innerHTML = "<span>" + element.textContent + "</span>";
    });
  }
});

// sp burger
document.addEventListener('DOMContentLoaded', () => {
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.header-burger-button'), 0);
  if ($navbarBurgers.length > 0) {

    //set
    const headerWrapClassName = 'header-nav-mobile';

    // navigation
    const headerWrap = document.createElement('div');
    headerWrap.classList.add(headerWrapClassName);
    headerWrap.classList.add('is-hidden');

    // const headerNav = document.createElement('div');
    // headerNav.classList.add('header-nav-mobile-header');
    // headerNav.appendChild(document.getElementsByClassName("header-nav")[0].cloneNode(true));

  // header sp
  document
    .querySelectorAll(".header-nav-mobile-header li.wp-block-navigation-submenu")
    .forEach((element) => {
      element.querySelector(".wp-block-navigation-submenu__toggle").classList.remove("wp-block-navigation-submenu__toggle")
      element.querySelector(".wp-block-navigation__submenu-icon").remove();
      element.querySelector("button").classList.add("js-accordion-title")
      element.querySelector("ul").removeAttribute("class")
      element.querySelector("li").removeAttribute("class")
    });

    document.getElementsByTagName('body')[0].insertAdjacentElement("beforeend",headerWrap);

    // burger
    $navbarBurgers.forEach(el => {
      el.addEventListener('click', () => {
        const target = el.dataset.target;
        const $target = document.getElementById(target);
        el.classList.toggle('is-active');
        document.getElementsByTagName('html')[0].classList.toggle('has-modal-open');
        document.querySelector('.'+headerWrapClassName).classList.toggle('is-hidden');
        document.getElementsByClassName("header")[0].classList.toggle('is-menu-open');
      });
    });
  }
});
